import type { Transactable } from '@src/domains/transactables/types/transactable';

import { SUMMARY_SOURCE } from '@src/domains/transactables/constants';
import type { SummarySource } from '@src/domains/transactables/types/summarySource';

export const isDirectLinkCartPresentation = (source: SummarySource, transactable: Transactable) =>
  source === SUMMARY_SOURCE.DIRECT_LINK && transactable.directLink?.type === 'cart';

export const isCartSummaryPresentation = (source: SummarySource, transactable: Transactable) =>
  source === SUMMARY_SOURCE.CART || isDirectLinkCartPresentation(source, transactable);

export const canManageCartCoupon = (source: SummarySource, transactable: Transactable) =>
  isCartSummaryPresentation(source, transactable) && !isDirectLinkCartPresentation(source, transactable);

export const isOrderSummaryPresentation = (source: SummarySource) => source === SUMMARY_SOURCE.ORDER;

export const isDirectLinkSalePresentation = (source: SummarySource, transactable: Transactable) =>
  source === SUMMARY_SOURCE.DIRECT_LINK && transactable.directLink?.type === 'sale';

export const isSaleSummaryPresentation = (source: SummarySource, transactable?: Transactable) =>
  source === SUMMARY_SOURCE.SALE || (transactable ? isDirectLinkSalePresentation(source, transactable) : false);

export const isSaleChangeSummaryPresentation = (source: SummarySource) => source === SUMMARY_SOURCE.SALE_CHANGE;

export const isDirectLinkPaymentPresentation = (source: SummarySource, transactable: Transactable) =>
  source === SUMMARY_SOURCE.DIRECT_LINK && transactable.directLink?.type === 'payment';
